import type { ICurrentLocationService } from "@/data/services/CurrentLocationService";

import { TastierGlobal } from "@/portal/globalAccess";

export class PortalCurrentLocationService implements ICurrentLocationService {
    public getLocationId(): string | undefined {
        return TastierGlobal.getLocationSwitch()?.getCurrentLocationId();
    }
}
